import { defineMessages } from 'react-intl';

export const i18n: {
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterProjectLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterSpacesLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	project: {
		id: 'search-page.filters.names.project',
		defaultMessage: 'Project',
		description: 'Label for filtering by project',
	},
	jiraFilterProjectPlaceholder: {
		id: 'search-page.jira.filter.project.placeholder',
		defaultMessage: 'Find projects',
		description: 'Placeholder for project filter search input',
	},
	jiraFilterProjectLabelSelected: {
		id: 'search-page.jira.filter.project.selected',
		defaultMessage: 'Selected',
		description: 'Jira project filter selected label',
	},
	jiraFilterProjectLabelUnselected: {
		id: 'search-page.jira.filter.project.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira project filter unselected label',
	},
	spaces: {
		id: 'search-page.filters.names.spaces',
		defaultMessage: 'Space',
		description: 'Label for filtering by space',
	},
	jiraFilterSpacesPlaceholder: {
		id: 'search-page.jira.filter.spaces.placeholder',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for spaces search input',
	},
	jiraFilterSpacesLabelSelected: {
		id: 'search-page.jira.filter.spaces.selected',
		defaultMessage: 'Selected',
		description: 'Jira spaces filter selected label',
	},
	jiraFilterSpacesLabelUnselected: {
		id: 'search-page.jira.filter.spaces.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira spaces filter unselected label',
	},
});
